import storage from './storage';

const MAX_ENTRIES = 500;

/** Every user (including admin) gets their own audit log. */
function key(userId) {
  return userId ? `crm_audit_u${userId}` : 'crm_audit';
}

export const auditService = {
  getAll(userId) {
    return storage.get(key(userId), []);
  },

  saveAll(userId, log) {
    storage.set(key(userId), log.slice(0, MAX_ENTRIES));
  },

  /** Prepends a new entry to the log. */
  addEntry(userId, entry) {
    const log = this.getAll(userId);
    this.saveAll(userId, [entry, ...log]);
  },
};
